'use strict';

/*global services*/
/*global OrderConfirm*/

function initialize($wrapper) {
  $wrapper.find('.searchSelect').selectpicker({
    style: 'btn-default',
    liveSearch: true
  });

  $wrapper.find('.loadOtherItems').k2_loadOtherItems();
  $wrapper.find('.char-counter').k2_charCounter();
  $wrapper.find('.table').k2_tableCollapsible();
  $wrapper.find('.js-datepicker').datepicker({ language: services.get('configurations').param('locale'), format: services.get('configurations').param('date_format') });
}

$(document).ready(function () {
  initialize($('body'));

  //formular pro potvrzovani polozek
  new OrderConfirm('orderItems');
});
